// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

//header background
(function($) {
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (!$(document.body).hasClass('checkout') && !$(document.body).hasClass('error404')) {

      if (scrollTop > 220) {
        $('.banner').addClass('has-bg');
      } else {
        $('.banner').removeClass('has-bg');
      }
    }
  });

  if ($(document.body).hasClass('checkout')) {
    $('.tickera_additional_info').addClass('col-lg-6');
  }

  $('.modal-button').click(function() {
    $('.ticket-modal').toggleClass('modal-open');
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      $('.ticket-modal').removeClass('modal-open');
    }
  });

  ////CUSTOM ADD TO CART
  $('.qty-modal').change(function() {
    var home = window.location.origin;
    var newUrl = home + '?add-to-cart=';
    var poductarray = [];
    var button = $('.modal-add-to-cart');

    $('.qty-modal').each(function() {
      var qty = $(this).find('.qty').val();
      var id = $(this).attr('id');

      if (qty !== 0) {
        for(var i = 0; i < qty; i++) {
          poductarray.push(id);
        }
      }
    });

    if (poductarray.length !== 0) {
      for( var x = 0; x < poductarray.length; x++ ) {
        newUrl += poductarray[x];

        if (x !== (poductarray.length -1)) {
          newUrl += ',';
        }
      }
      button.addClass('active');
      button.attr('href', newUrl);
    } else {
      button.removeClass('active');
      button.attr('href', '#');
    }
  });

  //Input plus-minus buttons voor single product & cart
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(
      parent.find('input[name="' + fieldName + '"]').val(),
      10
    );

    if (!isNaN(currentVal)) {
      parent
        .find('input[name="' + fieldName + '"]')
        .val(currentVal + 1)
        .trigger('change');
    } else {
      parent.find('input[name="' + fieldName + '"]').val(0);
    }
    $('#cartbutton').attr('data-quantity', currentVal+1);
  }

  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(
      parent.find('input[name="' + fieldName + '"]').val(),
      10
    );

    if (!isNaN(currentVal) && currentVal > 0) {
      parent
        .find('input[name="' + fieldName + '"]')
        .val(currentVal - 1)
        .trigger('change');
    } else {
      parent.find('input[name="' + fieldName + '"]').val(0);
    }
    $('#cartbutton').attr('data-quantity', currentVal-1);
  }

  $(document).on('click', '.button-plus', function (e) {
    incrementValue(e);
  });

  $(document).on('click', '.button-minus', function (e) {
    decrementValue(e);
  });

  //update cart on quantity change
  var timeout;
  $(document).on('change', '.shop_table input.qty', function () {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }
    $('.update-cart-button').removeAttr('disabled');
    timeout = setTimeout(function () {
      $('[name="update_cart"]').trigger('click');
      clearTimeout(timeout);
    }, 1000); // 1 second delay, half a second (500) seems comfortable too
  });

  //update cart on remove last product
  /*var timeout;*/
  $(document).on('click', '.remove', function () {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }

    $('.update-cart-button').removeAttr('disabled');
    timeout = setTimeout(function () {
      $('[name="update_cart"]').trigger('click');
      clearTimeout(timeout);
    }, 1000); // 1 second delay, half a second (500) seems comfortable too
  });

}(jQuery));

/*jQuery('section.content-ticket-request a.add_to_cart').on('click', (e) => {
  e.preventDefault();

  let variations = [];
  let productId;

  jQuery('section.content-ticket-request .custom-control-input:checked').each(function () {
    variations.push({id: parseInt($(this).data('variation-id')), qty: 1});
    productId = parseInt($(this).data('product-id'));
  });

  jQuery('section.content-ticket-request .custom-select').each(function () {
    variations.push({
      id: parseInt($(this).parent('div').data('variation-id')),
      qty: parseInt($(this).val()),
    });
    productId = parseInt($(this).parent('div').data('product-id'));
  });

  console.log(variations)

  if (variations.length > 0) {
    // AJAX add to cart
    let data = {
      action: 'custom_add_to_cart',
      product_id: productId,
      variations: variations,
    };

    $.post(window.tc_ajax.ajaxUrl, data).then((data, status) => {
      if (status !== 'success') {
        throw new Error('Er is een fout opgetreden tijdens het bijwerken van je winkelwagen.');
      }
      return JSON.parse(data);
    }).then((response) => {
      if (response.success === true) {
        window.location.href = response.cart_url;
      } else {
        throw new Error('Er is een fout opgetreden tijdens het bijwerken van je winkelwagen.');
      }
    }).catch((e) => {
      alert(e.message)
    });
  }
});

jQuery('section.content-ticket-request .custom-control-input').on('change', function () {
  let totalPrice = 0;
  jQuery('section.content-ticket-request .custom-control-input:checked').each(function () {
    totalPrice += parseFloat($(this).data('variation-price'));
  });

  $('.content-ticket-request__total-amount').text(totalPrice.toString().replace('.', ','));

  if (totalPrice === 0) {
    $('.content-ticket-request .btn-primary').addClass('disabled');
  } else {
    $('.content-ticket-request .btn-primary').removeClass('disabled');
  }
});*/



// WEBPACK FOOTER //
// ./scripts/main.js